import { cn } from "@/lib/utils";

export function HudCard({ className, children, label, ...props }) {
  return (
    <div className={cn("hud-panel reticle clip-corner", className)} {...props}>
      <span className="rc-tr" />
      <span className="rc-bl" />
      {label && (
        <div className="flex items-center gap-2 px-4 pt-3 pb-2 border-b border-[var(--border-hud)]">
          <span className="h-1.5 w-1.5 rounded-full bg-[var(--accent)] accent-glow" />
          <span className="font-mono-hud text-[11px] tracking-[0.25em] uppercase text-[var(--accent)]">{label}</span>
        </div>
      )}
      {children}
    </div>
  );
}
